$(document).ready(function () {
    $('[data-student]').change(function () {
        $(this.form).submit();
    });
});


$(document).ready(function () {
    $('[data-program-cycle]').change(function () {
        $(this.form).submit();
    });
});
